import React, { ReactElement } from 'react';
import { Form, InputNumber } from 'antd';

import { FieldCurrencyTypes } from 'pricing/types';
import number from 'utilities/number/number';
import { costValidation } from './costValidation';

interface Props {
  label: string;
  name: string;
  type: FieldCurrencyTypes;
}

function FieldCurrency(props: Props): ReactElement {
  const { label, name, type } = props;

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) => prevValues.breedId !== curValues.breedId}
    >
      {() => (
        <Form.Item
          label={label}
          name={name}
          rules={
            type === 'Cost'
              ? [costValidation(type)]
              : [{ required: true, message: 'This field is required' }]
          }
        >
          <InputNumber
            data-testid={`field-${name}`}
            style={{ width: '100%' }}
            formatter={number.formatterCurrency}
            parser={number.removeNonDigits}
            min={0}
            step={50}
          />
        </Form.Item>
      )}
    </Form.Item>
  );
}

export default FieldCurrency;
